var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDepositLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-filled-money-tool",
    transform: "translate(0 -17.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23045",
    "data-name": "Group 23045",
    transform: "translate(0 17.84)",
    fill: "#74276b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42824",
    "data-name": "Path 42824",
    d: "M160.482,21.076l7.176-1.927-.38-.756a1.019,1.019,0,0,0-1.354-.449L159.5,21.076Z",
    transform: "translate(-156.276 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42825",
    "data-name": "Path 42825",
    d: "M329.1,86.46a1.026,1.026,0,0,0-.267.036l-1.686.453L322,88.331h8.391l-.315-1.138A1.006,1.006,0,0,0,329.1,86.46Z",
    transform: "translate(-315.491 -85.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42826",
    "data-name": "Path 42826",
    d: "M15.952,215.56H1.013a1.015,1.015,0,0,0-.79.374.99.99,0,0,0-.186.36,1.014,1.014,0,0,0-.036.261v11.079a1,1,0,0,0,1.011.994H15.95a1,1,0,0,0,1.011-.994v-2.774h-6a1.706,1.706,0,0,1-1.718-1.69v-2.211a1.669,1.669,0,0,1,.487-1.177,1.711,1.711,0,0,1,1.025-.5,1.736,1.736,0,0,1,.2-.012h6v-2.715A1,1,0,0,0,15.952,215.56Z",
    transform: "translate(0 -211.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42827",
    "data-name": "Path 42827",
    d: "M500.117,437.021a1.013,1.013,0,0,0-.354-.207,1.046,1.046,0,0,0-.327-.054h-6.026a1,1,0,0,0-1.011.994v2.213a1,1,0,0,0,1.011.994h6.026a1.046,1.046,0,0,0,.327-.054,1,1,0,0,0,.683-.941v-2.213A.984.984,0,0,0,500.117,437.021Zm-4.6,2.038a.5.5,0,0,1-.505.5h-.336a.5.5,0,0,1-.505-.5v-.33a.484.484,0,0,1,.194-.39.516.516,0,0,1,.311-.107h.336a.5.5,0,0,1,.505.5v.33Z",
    transform: "translate(-482.447 -428.43)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDepositLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_deposit_limit.80f6cf206a8dd9d05849d7f85fe08056.svg";